import { QuestionCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { FormattedMessage, FormattedNumber, defineMessages, useIntl } from "react-intl";
import styles from "./style.module.css";

const messages = defineMessages({
  heading: { id: "candidate.instructions.heading", defaultMessage: "Instructions" },
  standardCopy: {
    id: "candidate.instructions.standardCopy",
    defaultMessage:
      "Before you start, please keep in mind the following information to ensure you pace yourself appropriately:",
  },
  questions: {
    id: "candidate.assessment.questionsLabel",
    defaultMessage: "{count, plural, one {Question} other {Questions}}",
  },
  timeLimit: { id: "candidate.instructions.timeLimit", defaultMessage: "Time Limit" },
  unlimited: { id: "candidate.instructions.unlimited", defaultMessage: "Unlimited" },
  minutes: { id: "candidate.instructions.minutes", defaultMessage: "{minutes, number} min" },
});

export interface StandardizedInstructionsBlockProps {
  questionCount: number;
  timeLimitMinutes: number;
}

export function StandardizedInstructionsBlock({ questionCount, timeLimitMinutes }: StandardizedInstructionsBlockProps) {
  const intl = useIntl();
  const timeDisplayText =
    timeLimitMinutes > 0
      ? intl.formatMessage(messages.minutes, { minutes: timeLimitMinutes })
      : intl.formatMessage(messages.unlimited);

  return (
    <div className={styles.container}>
      <h2 className={styles.header}>
        <FormattedMessage {...messages.heading} />
      </h2>
      <div className={styles.divider} />

      <p className={styles.standardCopy}>
        <FormattedMessage {...messages.standardCopy} />
      </p>

      <dl className={styles.infoCardsContainer}>
        <div className={styles.infoCard}>
          <dt className={styles.infoCardLabel}>
            <QuestionCircleOutlined className={styles.infoCardIcon} aria-hidden="true" />
            <FormattedMessage {...messages.questions} values={{ count: questionCount }} />
          </dt>
          <dd className={styles.infoCardNumber}>
            <FormattedNumber value={questionCount} />
          </dd>
        </div>

        <div className={styles.infoCard}>
          <dt className={styles.infoCardLabel}>
            <ClockCircleOutlined className={styles.infoCardIcon} aria-hidden="true" />
            <FormattedMessage {...messages.timeLimit} />
          </dt>
          <dd className={styles.infoCardNumber}>{timeDisplayText}</dd>
        </div>
      </dl>
    </div>
  );
}
